import {useState} from 'react'
import get from 'lodash/get';
import useAPI from 'src/hooks/useAPI';
import logger from 'src/utils/logger';
import { noop } from 'src/utils/event';

/**
 * @description useGenerateCloudinaryToken hook to generate a token for cloudinary when we try to upload assets.
 * - Only good for 10 minutes, since no react-query, we'll all it every time.
 */

export const useSignedToken = () => {
  const [response, setResponse] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  /* Hooks */
  const APIS = useAPI();

  /* Api */
  const mutate = async (params, {onSuccess = noop, onError = noop}) => {
    setLoading(true);
    const signedToken = await APIS.cloudinary.getAuthToken(params);
    setLoading(false);
    if (signedToken.err) {
      logger.log('cloudinary signed token: ', signedToken.err)
      setError(signedToken.err);
      onError([{
        status: 'rejected',
        reason: {message: `Error uploading file: ${get(signedToken, 'data.error', '')}`},
      }])
    } else {
      setResponse(signedToken.data);
      onSuccess(signedToken.data);
    }
  }

  return {response, error, loading, mutate}
}
